import JsUtil from '../util/JsUtil.js';

/**
 * Lookup for corpus data
 */
const IdsCorpusLookup = {
  /** The initially selected and loaded corpus IDs */
  initialCorpusIds: [],

  /** The current corpus list used in the application */
  corpusList: [],

  /** Link template for the corpus description website */
  corpusLinkTpl: 'https://agd.ids-mannheim.de/{0}_extern.shtml',

  /**
   * Sets the given corpus list to the #corpusList lookup variable.
   *
   * @param {Array} corpusList The new corpus list to set
   */
  setCorpusList (corpusList) {
    IdsCorpusLookup.corpusList = corpusList;
  },

  /**
   * Returns the corpus object delivered by the API.
   *
   * @param {String} corpusId The corpus ID as returned from the API (e.g. 'ZW')
   * @returns The corpus object
   */
  getCorpus (corpusId) {
    return IdsCorpusLookup.corpusList.find(c => {
      return c.v_corpus_id === corpusId;
    });
  },

  /**
   * Detects if the given corpus is in the list of available corpora.
   *
   * @param {String} corpusId The ID of the corpus, e.g. "PF--"
   * @returns true => is in corpus list, false => not in list
   */
  isExistingCorpus (corpusId) {
    let existing = false;
    IdsCorpusLookup.corpusList.forEach(korp => {
      if (korp.v_corpus_id === corpusId) {
        existing = true;
      }
    });

    return existing;
  },

  /**
   * Returns the selection array with all corpus selected for the given
   * category.
   *
   * @param {String} corpusCat
   * @returns Array with all corpus entries as selected
   */
  getAllSelected (corpusCat) {
    const aggregate = [];
    IdsCorpusLookup.corpusList.forEach(korp => {
      if (korp.v_corpus_cat === corpusCat) {
        aggregate.push(korp.v_corpus_id);
      }
    });

    return aggregate;
  },

  /**
   * Returns the selection object for the 'ids-filter-module-win'
   * component.
   * Like {"SPRACHVARIETÄTENKORPORA - DEUTSCHSPRACHIGES KERNGEBIET": [null, null, "MV--", null]}
   *
   * @param {Array} corpusIds Array of IDs of the corpora, e.g. ["PF--", "MV--"]
   * @returns The selection object
   */
  getSelectionObjectByArr (corpusIds) {
    const aggregate = {};

    IdsCorpusLookup.corpusList.forEach(korp => {
      const corpusId = corpusIds.find(x => x === korp.v_corpus_id);
      if (!aggregate[korp.v_corpus_cat]) {
        aggregate[korp.v_corpus_cat] = [];
      }
      if (korp.v_corpus_id === corpusId) {
        aggregate[korp.v_corpus_cat].push(corpusId);
      } else {
        aggregate[korp.v_corpus_cat].push(null);
      }
    });

    return aggregate;
  },

  /**
   * Returns a selection object with no selection, can be used to reset all
   * corpus selections over all categories.
   *
   * @returns The emty selection object
   */
  getEmptySelectionObject () {
    const aggregate = {};
    IdsCorpusLookup.corpusList.forEach(korp => {
      if (!aggregate[korp.v_corpus_cat]) {
        aggregate[korp.v_corpus_cat] = [];
      }
      aggregate[korp.v_corpus_cat].push(null);
    });

    return aggregate;
  },

  /**
   * Returns the label for a corpus.
   *
   * @param {String} corpusId The corpus ID as returned from the API (e.g. 'ZW')
   * @returns The corpus label, e.g. 'Deutsche Mundarten: Zwirner-Korpus (ZW--)'
   */
  getCorpusLabel (corpusId) {
    const corpus = IdsCorpusLookup.getCorpus(corpusId);
    if (!corpus) {
      return;
    }
    const corpId = corpus.v_corpus_id;
    const paddedCorpId = corpId.padEnd(4, '-'); // ensure 4 chars ZW => ZW--

    return `${corpus.v_corpus_name} (${paddedCorpId})`;
  },

  /**
   * Returns the URL to the corpus description website.
   *
   * @param {String} corpusId The corpus ID as returned from the API (e.g. 'ZW')
   * @returns URL, like https://agd.ids-mannheim.de/ZW--_extern.shtml
   */
  getCorpusLink (corpusId) {
    const corpus = IdsCorpusLookup.getCorpus(corpusId);
    if (!corpus) {
      return;
    }

    const padCorpId = corpusId.padEnd(4, '-'); // ensure 4 chars ZW => ZW--
    return JsUtil.formatString(IdsCorpusLookup.corpusLinkTpl, padCorpId);
  }
};

export default IdsCorpusLookup;



// WEBPACK FOOTER //
// ./app/ids/IdsCorpusLookup.js